import moment from "moment";
import {FLYER_TYPE_PREVIEW} from "@/components/core/flyer/Flyer";
import router from "@/router";

const state = {};

const getters = {
	flyers(state, getters, rootState) {
		return rootState.landingPage.flyers;
	},
	flyersById(state, getters) {
		return getters.flyers.reduce((acc, flyer) => {
			acc[flyer.id] = flyer;
			return acc;
		}, {});
	},
	flyersByDeal(state, getters) {
		return getters.flyers.reduce((acc, flyer) => {
			acc[flyer.title] = flyer;
			return acc;
		}, {});
	},
	dealId(state, getters, rootState) {
		return rootState.landingPage.flyerId;
	},
	currentFlyer(state, getters) {
		const dealId = getters.dealId;
		return getters.flyersByDeal[dealId] ?? null;
	},


	/**
	 * Retrieves the flyer type of the current flyer from the getters.
	 *
	 * @param {Object} state - The state object.
	 * @param {Object} getters - The getters object containing derived state properties.
	 * @return {string|undefined} Returns the type of the current flyer if available, otherwise undefined.
	 */
	flyerType(state, getters) {
		return getters.currentFlyer?.flyerType;
	},

	zone(state, getters) {
		return getters.currentFlyer?.zonedPublicationName
	},



	/**
	 * Computes and returns the starting date of the current flyer set to the beginning of the day.
	 *
	 * @return {Moment} A Moment.js object representing the start date of the current flyer at the start of the day.
	 */
	validFromFlyer(state, getters) {
		return moment.utc(getters.currentFlyer.startDate, 'YYYY-MM-DD').startOf('day');
	},

	/**
	 * Determines the end of the day for the current flyer's end date.
	 *
	 * This method calculates the end of the day for the `endDate` property of the `currentFlyer` object
	 * using the Moment.js library.
	 *
	 * @return {Moment} A Moment.js object representing the end of the day of the current flyer's end date.
	 */
	validToFlyer(state, getters) {
		return moment.utc(getters.currentFlyer.endDate, 'YYYY-MM-DD').endOf('day');
	},

	/**
	 * Retrieves the current date, either from the `timeTravelDate` query parameter or defaults to the current system date converted to utc.
	 * If the `timeTravelDate` query parameter is invalid or not provided, the method returns the current date (UTC).
	 * If the flyer type is preview, it returns the valid from date of the flyer. Since preview flyer dates are not valid from the current date, this ensures it is calculated as if it is.
	 *
	 * @return {moment.Moment} A moment object representing either the parsed `timeTravelDate` or the current date (UTC) or the Preview Flyer Date.
	 */
	currentDate(state, getters) {
		if(getters.flyerType === FLYER_TYPE_PREVIEW)	{
			return getters.validFromFlyer;
		}
		const date = moment.utc(router.currentRoute.query['timeTravelDate']);
		if(date.isValid() && router.currentRoute.query['timeTravelDate']) return date;

		return moment().startOf('day').utc();
	},
};

export default {
	namespaced: true,
	state,
	getters
};
